var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-login-page',{class:[("login-page__" + _vm.loginType)],attrs:{"loginType":_vm.loginType}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }